import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";
import { Section } from "../components/ui/Section";

export function NotFoundPage() {
  return (
    <Section className="py-12 sm:py-16">
      <Card className="mx-auto max-w-xl text-center">
        <h1 className="text-3xl font-bold text-white">Η σελίδα δεν βρέθηκε</h1>
        <p className="mt-3 text-slate-300">Ο σύνδεσμος που άνοιξες δεν αντιστοιχεί σε διαθέσιμη δημόσια σελίδα.</p>
        <Button className="mt-6 w-full sm:w-auto" href="/">
          Επιστροφή στην αρχική
        </Button>
      </Card>
    </Section>
  );
}
